import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import Avatar from '../components/common/Avatar';
import Icon from 'react-native-vector-icons/MaterialIcons';

export interface AvatarCardProps {
  avatarUrl?: string | null;
  displayName?: string | null;
  email?: string | null;
  isVip?: boolean;
  points?: number;
  onEdit?: () => void;
  onAvatarUpload?: () => void;
}

const AvatarCard: React.FC<AvatarCardProps> = ({ avatarUrl, displayName, email, isVip, points, onEdit, onAvatarUpload }) => {
  return (
    <View style={styles.container}>
      <View style={styles.left}>
        <View style={{ position: 'relative' }}>
          <Avatar avatarUrl={avatarUrl ?? null} size="xl" displayName={displayName ?? undefined} email={email ?? undefined} />
          {/* camera overlay for avatar upload */}
          {onAvatarUpload ? (
            <TouchableOpacity onPress={onAvatarUpload} style={styles.cameraOverlay} accessibilityRole="button">
              <Icon name="photo_camera" size={16} color="#fff" />
            </TouchableOpacity>
          ) : null}
        </View>
        {typeof isVip !== 'undefined' && (
          <View style={[styles.roleBadge, { backgroundColor: isVip ? '#F59E0B' : '#6B7280' }]}>
            <Text style={styles.roleText}>{isVip ? 'VIP' : 'Member'}</Text>
          </View>
        )}
      </View>

      <View style={styles.right}>
        <Text style={styles.name}>{displayName ?? 'User'}</Text>
        {email ? <Text style={styles.email}>{email}</Text> : null}
        <View style={styles.pointsBadge}>
          <Text style={styles.pointsText}>{(points || 0)} pts</Text>
        </View>
      </View>

      {onEdit ? (
        <TouchableOpacity style={styles.editBtn} onPress={onEdit} accessibilityRole="button">
          <Icon name="edit" size={18} color="#2563EB" />
        </TouchableOpacity>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flexDirection: 'row', alignItems: 'center', paddingVertical: 12 },
  left: { position: 'relative' },
  right: { marginLeft: 12, flex: 1 },
  name: { fontSize: 18, fontWeight: '700', color: '#111827' },
  email: { fontSize: 13, color: '#6B7280', marginTop: 4 },
  roleBadge: { position: 'absolute', bottom: -6, right: -6, paddingHorizontal: 8, paddingVertical: 2, borderRadius: 12, borderWidth: 2, borderColor: '#fff' },
  roleText: { fontSize: 10, fontWeight: '700', color: '#fff' },
  pointsBadge: { marginTop: 8, backgroundColor: '#F7931E', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, alignSelf: 'flex-start' },
  pointsText: { color: '#fff', fontWeight: '700' },
  editBtn: { marginLeft: 12, paddingHorizontal: 12, paddingVertical: 8 },
  editText: { color: '#2563EB', fontWeight: '700' },
  cameraOverlay: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    backgroundColor: '#2563EB',
    width: 28,
    height: 28,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#fff',
  },
});

export default AvatarCard;
